import Popup from "@arcgis/core/widgets/Popup";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils.js";
import Features from "@arcgis/core/widgets/Features.js";

import { WinGISMap } from "../../createMap";
import { conditionalMapOptions } from "../../util/importConditions";
import { symbol, pointSymbol } from "./highlightSymbols";


export let features = new Features();

export function initializeDetails(view) {
    if (conditionalMapOptions.addAdvancedUI) {
      features.container = "features-widget";
      view.popup = features;
    } else {
      let popup = new Popup({ content: features });
      view.popup = popup;
    }
  
    reactiveUtils.watch(() => features.selectedFeature, () => {
      WinGISMap.view.graphics == null;
      if (features.selectedFeature) { 
        WinGISMap.view.graphics.removeAll();
        let graphic;
        if (features.selectedFeature.geometry.type !== 'point') {
          graphic = {
            geometry: features.selectedFeature.geometry,
            symbol: symbol
          };
        } else {
          graphic = {
            geometry: features.selectedFeature.geometry,
            symbol: pointSymbol
          };
        }
        WinGISMap.view.graphics.add(graphic);
      }
    });
    return features;
}